import {Box, Grid, Stack, Heading} from '@primer/react-brand'
import {ContentfulCards} from '@github-ui/swp-core/components/contentful/ContentfulCards'

import type {ResourceDetailsPage} from '../../lib/types/contentful'

import styles from './ResourceDetailsPage.module.css'

type RelatedResourcesProps = {
  component: ResourceDetailsPage
}

export default function Aside({component}: RelatedResourcesProps) {
  const {relatedResources} = component.fields

  if (!relatedResources || relatedResources.length <= 0) {
    return null
  }

  return (
    <Box
      paddingBlockStart={{narrow: 48, regular: 80}}
      paddingBlockEnd={{narrow: 64, regular: 96}}
      backgroundColor="subtle"
    >
      <Grid>
        <Grid.Column>
          <Stack direction="vertical" padding="none" gap={{narrow: 40, regular: 64}}>
            <Heading as="h2" size="5">
              Explore other resources
            </Heading>
            <ContentfulCards
              cards={relatedResources}
              className={styles.relatedCards}
              imageAspectRatio="16:9"
              fullWidth
            />
          </Stack>
        </Grid.Column>
      </Grid>
    </Box>
  )
}

try{ Aside.displayName ||= 'Aside' } catch {}